import { useEffect } from "react";
import { object, string, mixed, number, date, array } from "yup";
import i18n from "../../../../locales/i18n";
import { email_regex, name_regex } from "../../../../utils/regex";
import {
  customerTypeEnum,
  customerKindEnum,
  isExists,
  supplierEnum,
  params,
  communicationTypeEnum,
} from "../../../../utils";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  selectIdentityCardTypes,
  setIdentityCardTypes,
} from "../../../../features/customer/customerSlice";
import { useGetListQuery } from "../../../../features/api/Api";
import { TurkeyNationalityId } from "../../../../utils/enum";
import { error } from "console";

const generalValidation = (identityCardTypes: any[]) => {
  const generalValidationSchema = object({
    customerId: string()
      //.required(i18n.t("resources.customers.valid.select_customerTypeId"))
      .test("Lütfen Müşteri Seçiniz", "Lütfen Müşteri Seçiniz", function () {
        if (this.parent.isExistCustomer) {
          return isExists(this.parent.customerId);
        } else {
          return true;
        }
      }),

    customerTypeId: number()
      //.required(i18n.t("resources.customers.valid.select_customerTypeId"))
      .test(
        i18n.t("resources.customers.valid.select_customerTypeId"),
        i18n.t("resources.customers.valid.select_customerTypeId"),
        function () {
          if (!this.parent.isExistCustomer) {
            return isExists(this.parent.customerTypeId);
          } else {
            return true;
          }
        }
      ),
    customerKindId: number().required(
      i18n.t("resources.customers.valid.select_customerKindId")
    ),
    dateOfBirth: mixed()
      /* .typeError(
        i18n.t("resources.customers.related_persons.valid.dateOfBirth")
      ) */
      .test(
        i18n.t("resources.customers.related_persons.valid.select_dateOfBirth"),
        i18n.t("resources.customers.related_persons.valid.select_dateOfBirth"),
        function () {
          const { customerKindId, isExistCustomer }: any = this.parent;

          if (
            (customerKindId !== customerKindEnum.indivual &&
              !isExists(this.parent.dateOfBirth)) ||
            isExistCustomer
          ) {
            return true;
          } else {
            return isExists(this.parent.dateOfBirth);
          }
        }
      )
      .nullable(),
    citizenOrTaxNumber: string()
      .nullable()
      .when("customerDetail", {
        is: (customerDetail: any) => customerDetail.isForeign,
        then: string().nullable(),
        otherwise: string().when(
          ["customerTypeId", "customerDetail", "isExistCustomer"],
          {
            is: (
              customerTypeId: number,
              customerDetail: any,
              isExistCustomer: boolean
            ) =>
              !isExistCustomer &&
              customerTypeId !== customerTypeEnum.lead &&
              !customerDetail.isForeign,
            then: string()
              .nullable()
              .when(["customerKindId", "isExistCustomer"], {
                is: (customerKindId: number, isExistCustomer: boolean) =>
                  !isExistCustomer &&
                  (Number(customerKindId) === customerKindEnum.indivual ||
                    Number(customerKindId) ===
                      customerKindEnum.soleProprietorship),
                then: string()
                  .nullable()
                  .matches(/^[0-9]+$/, "Must be only digits")
                  .min(11, i18n.t("resources.customers.valid.equal_11"))
                  .max(11, i18n.t("resources.customers.valid.equal_11"))
                  .required(i18n.t("resources.customers.valid.enter_tcno")),
                otherwise: string()
                  .nullable()
                  .matches(/^[0-9]+$/, "Must be only digits")
                  .min(10, i18n.t("resources.customers.valid.equal_10"))
                  .max(10, i18n.t("resources.customers.valid.equal_10"))
                  .required(i18n.t("resources.customers.valid.enter_vkno")),
              }),
          }
        ),
      }),
    name: mixed().when(["customerKindId", "isExistCustomer"], {
      is: (customerKindId: number, isExistCustomer: boolean) =>
        customerKindId === 1 && !isExistCustomer,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_customer_name"))
        .test(
          i18n.t("resources.customers.valid.valid_name"),
          i18n.t("resources.customers.valid.valid_name"),
          function () {
            if (
              !this.parent.isExistCustomer &&
              !name_regex.test(this.parent.name)
            ) {
              return false;
            } else {
              return true;
            }
          }
        ),
    }),
    surname: mixed().when(["customerKindId", "isExistCustomer"], {
      is: (customerKindId: number, isExistCustomer: boolean) =>
        customerKindId === 1 && !isExistCustomer,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_customer_surname"))
        .test(
          i18n.t("resources.customers.valid.valid_surname"),
          i18n.t("resources.customers.valid.valid_surname"),
          function () {
            if (
              !this.parent.isExistCustomer &&
              !name_regex.test(this.parent.surname)
            ) {
              return false;
            } else {
              return true;
            }
          }
        ),
    }),
    email: string().when("customerDetail", {
      is: (customerDetail: any, isExistCustomer: boolean) =>
        customerDetail.isForeign && !isExistCustomer,
      then: string()
        .email(i18n.t("resources.customers.valid.valid_email"))
        .required(i18n.t("resources.customers.valid.enter_email")),
      otherwise: string().when("customerKindId", {
        is: (customerKindId: any, isExistCustomer: boolean) =>
          Number(customerKindId) === customerKindEnum.corporate &&
          !isExistCustomer,
        then: string()
          .nullable()
          .email(i18n.t("resources.customers.valid.valid_email")),
        otherwise: string().nullable(true),
      }),
    }),
    commercialTitle: mixed().when("customerKindId", {
      is: (customerKindId: number) =>
        customerKindId !== customerKindEnum.indivual,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_commercialTitle")),
    }),
    alias: mixed().when("customerKindId", {
      is: (customerKindId: number) =>
        customerKindId !== customerKindEnum.indivual,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_alias")),
    }),
    customerDetail: object().shape({
      statusId: string().required(
        i18n.t("resources.customers.valid.select_customerStatusId")
      ),
      sectorId: mixed().test(
        i18n.t("resources.customers.valid.select_sectorId"),
        i18n.t("resources.customers.valid.select_sectorId"),
        function () {
          const schema: any = this;
          const { customerTypeId }: any = schema.from[1].value;

          if (
            customerTypeId === customerTypeEnum.real &&
            !isExists(this.parent.sectorId)
          ) {
            return false;
          } else {
            return true;
          }
        }
      ),
      taxFreeReasonId: mixed().when("isTaxFree", {
        is: true,
        then: string().required(
          i18n.t("resources.customers.valid.select_taxFreeReasonId")
        ),
      }),
      conditionId: string().required(
        i18n.t("resources.customers.valid.select_conditionId")
      ),
      taxOfficeId: string()
        .test(
          i18n.t("resources.customers.valid.select_tax_office"),
          i18n.t("resources.customers.valid.select_tax_office"),
          function () {
            const schema: any = this;
            const {
              customerKindId,
              customerTypeId,
              customerDetail,
              isExistCustomer,
            }: any = schema.from[1].value;
            if (isExistCustomer) {
              return true;
            }
            if (
              Number(customerKindId) !== customerKindEnum.indivual &&
              !isExists(this.parent.taxOfficeId)
            ) {
              return false;
            } else {
              return true;
            }
          }
        )
        .nullable(),
      // supplierTypeId: mixed().when("isSupplier", {
      //   is: true,
      //   then: string().required(
      //     i18n.t("resources.customers.valid.select_supplierTypeId")
      //   ),
      // }),
      supplierTypeId: mixed().when("isSupplier", {
        is: true,
        then: string()
          .typeError(i18n.t("resources.customers.valid.select_supplierTypeId"))
          .required(i18n.t("resources.customers.valid.select_supplierTypeId")),
      }),
      partnerLevelId: mixed().when("isBusinessPartner", {
        is: true,
        then: number()
          .typeError(i18n.t("resources.customers.valid.select_sectorId"))
          .required(i18n.t("resources.customers.valid.select_partnerLevelId")),
      }),
      operatorCode: mixed().when("isOperator", {
        is: true,
        then: string()
          .max(
            4,
            i18n.t(
              "resources.customers.valid.not_valid_select_operatorCodeLength"
            )
          )
          .typeError(i18n.t("resources.customers.valid.select_operatorCode"))
          .required(i18n.t("resources.customers.valid.select_operatorCode")),
      }),
      mersisNo: string()
        .nullable()
        .matches(
          /^[0-9]+$/,
          i18n.t("resources.customers.valid.must_be_only_digit")
        )
        .min(16, i18n.t("resources.customers.valid.not_valid_mersisLength"))
        .max(16, i18n.t("resources.customers.valid.not_valid_mersisLength")),
      isActive: mixed().required(
        i18n.t("resources.customers.valid.select_isActive")
      ),
      eCommerceDescription: mixed().when("supplierTypeId", {
        is: (supplierTypeId: number) =>
          supplierTypeId === supplierEnum.e_commerce,
        then: string()
          .nullable()
          .required(
            i18n.t("resources.customers.valid.enter_eCommerceDescription")
          ),
      }),
    }),
    contact: object().shape({
      name: string()
        .required(
          i18n.t("resources.customers.related_persons.valid.enter_name")
        )
        .test(
          i18n.t("resources.customers.related_persons.valid.valid_name"),
          i18n.t("resources.customers.related_persons.valid.valid_name"),
          function () {
            return name_regex.test(this.parent.name);
          }
        ),
      surname: string()
        .required(
          i18n.t("resources.customers.related_persons.valid.enter_surname")
        )
        .test(
          i18n.t("resources.customers.related_persons.valid.valid_surname"),
          i18n.t("resources.customers.related_persons.valid.valid_surname"),
          function () {
            return name_regex.test(this.parent.surname);
          }
        ),
      nationalityId: mixed().test(
        i18n.t("resources.customers.related_persons.valid.nationality"),
        i18n.t("resources.customers.related_persons.valid.nationalityF"),
        function () {
          const schema: any = this;
          const { customerTypeId, contact }: any = schema.from[1].value;
          if (
            customerTypeId === customerTypeEnum.real &&
            contact.isAuthorizedPerson &&
            !isExists(this.parent.nationalityId) &&
            this.parent.nationalityId === TurkeyNationalityId
          ) {
            return false;
          } else {
            return true;
          }
        }
      ),
      identityNo: string().test(
        i18n.t(
          "resources.customers.related_persons.valid.enter_citizenOrTaxNumber"
        ),
        i18n.t(
          "resources.customers.related_persons.valid.enter_citizenOrTaxNumber"
        ),
        function () {
          const schema: any = this;
          const {
            customerTypeId,
            customerKindId,
            customerDetail,
            isExistCustomer,
          }: any = schema.from[1].value;
          if (!this.parent.isAuthorizedPerson || isExistCustomer) {
            return true;
          }

          if (
            customerTypeId === customerTypeEnum.real &&
            !isExists(this.parent.identityNo) &&
            customerKindId !== customerKindEnum.corporate &&
            this.parent.nationalityId === TurkeyNationalityId
          ) {
            return false;
          } else {
            return true;
          }
        }
      ),

      dateOfBirth: mixed()
        .test(
          i18n.t(
            "resources.customers.related_persons.valid.select_dateOfBirth"
          ),
          i18n.t(
            "resources.customers.related_persons.valid.select_dateOfBirth"
          ),
          function () {
            const schema: any = this;
            const { customerKindId, isExistCustomer }: any =
              schema.from[1].value;

            if (isExistCustomer && !isExists(this.parent.dateOfBirth)) {
              return true;
            } else {
              return isExists(this.parent.dateOfBirth);
            }
          }
        )
        .nullable(),

      jobTitleId: mixed().test(
        i18n.t("resources.customers.related_persons.valid.select_jobTitleId"),
        i18n.t("resources.customers.related_persons.valid.select_jobTitleId"),
        function () {
          const schema: any = this;
          const { isForeign }: any = schema.from[1].value.customerDetail;

          if (isForeign && this.parent.jobTitleId) return true;

          return isExists(this.parent.jobTitleId);
        }
      ),
      contactCommunication: array().of(
        object().shape({
          communicationTypeId: string().required(
            i18n.t(
              "resources.customers.related_persons.valid.select_communicationTypeId"
            )
          ),
          value: mixed().when("communicationTypeId", {
            is: communicationTypeEnum.e_mail.toString(),
            then: string()
              .email(
                i18n.t("resources.customers.related_persons.valid.valid_email")
              )
              .required(
                i18n.t("resources.customers.related_persons.valid.enter_email")
              ),
            /* .test(
                i18n.t(
                  "resources.customers.related_persons.valid.not_valid_email"
                ),
                i18n.t(
                  "resources.customers.related_persons.valid.not_valid_email"
                ),
                function () {
                  const schema: any = this;
                  
                  console.log(schema.from[2].value.isExistCustomer);
                  if (schema.from[2].value.isExistCustomer) {
                    return email_regex.test(this.parent.value) ? false : true;
                  } else {
                    return email_regex.test(this.parent.value) ? false : true;
                  }
                }
              ), */
            otherwise: string()
              .min(10, "En az 10 karakter olmalıdır.")
              .max(10, "En fazla 10 karakter olmalıdır.")
              .test(
                i18n.t("resources.customers.related_persons.valid.enter_value"),
                i18n.t("resources.customers.related_persons.valid.enter_value"),
                function () {
                  const schema: any = this;
                  const { customerTypeId }: any = schema.from[2].value;
                  const { kvkkMarkApprovalSmsSend }: any = schema.from[1].value;
                  if (kvkkMarkApprovalSmsSend && !this.parent.value)
                    return false;
                  if (
                    customerTypeId === customerTypeEnum.real &&
                    this.parent.communicationTypeId.toString() ===
                      communicationTypeEnum.mobile.toString() &&
                    !this.parent.value
                  )
                    return false;
                  else return true;
                }
              )
              .test(
                i18n.t(
                  "resources.customers.related_persons.valid.not_valid_phone_zero"
                ),
                i18n.t(
                  "resources.customers.related_persons.valid.not_valid_phone_zero"
                ),
                function () {
                  if (this.parent.value && this.parent.value.startsWith("0"))
                    return false;
                  return true;
                }
              )
              .test(
                i18n.t(
                  "resources.customers.related_persons.valid.not_valid_phone_zero"
                ),
                i18n.t(
                  "resources.customers.related_persons.valid.not_valid_phone_zero"
                ),
                function () {
                  if (this.parent.value && /\s/.test(this.parent.value))
                    return false;
                  return true;
                }
              ),
          }),
        })
      ),
      contactIdentityInformation: object().shape({
        identityCardTypeId: mixed().test(
          i18n.t(
            "resources.customers.related_persons.valid.select_identityCardId"
          ),
          i18n.t(
            "resources.customers.related_persons.valid.select_identityCardId"
          ),
          function () {
            const schema: any = this;
            const { isAuthorizedPerson }: any = schema.from[1].value;
            if (
              isAuthorizedPerson &&
              !isExists(this.parent.identityCardTypeId) &&
              !schema.from[2].value.isExistCustomer
            ) {
              return false;
            } else {
              return true;
            }
          }
        ),
        fatherName: mixed()
          .test(
            i18n.t(
              "resources.customers.related_persons.valid.enter_father_name"
            ),
            i18n.t(
              "resources.customers.related_persons.valid.enter_father_name"
            ),
            function () {
              const schema: any = this;
              const { isAuthorizedPerson, nationalityId }: any =
                schema.from[1].value;
              if (
                isAuthorizedPerson &&
                !isExists(this.parent.fatherName) &&
                nationalityId === TurkeyNationalityId &&
                !schema.from[2].value.isExistCustomer
              ) {
                return false;
              } else {
                return true;
              }
            }
          )
          .test(
            i18n.t("resources.customers.related_persons.valid.valid_name"),
            i18n.t("resources.customers.related_persons.valid.valid_name"),
            function () {
              return name_regex.test(this.parent.fatherName);
            }
          ),
        motherName: mixed()
          .test(
            i18n.t(
              "resources.customers.related_persons.valid.enter_mother_name"
            ),
            i18n.t(
              "resources.customers.related_persons.valid.enter_mother_name"
            ),
            function () {
              const schema: any = this;
              const { isAuthorizedPerson, nationalityId }: any =
                schema.from[1].value;

              if (
                this.parent.identityCardTypeId &&
                this.parent.identityCardTypeId ===
                  identityCardTypes.find(
                    (cardType: any) => cardType.name === "tc_passport"
                  )?.id &&
                !schema.from[2].value.isExistCustomer
              ) {
                return true;
              }
              if (
                isAuthorizedPerson &&
                !isExists(this.parent.motherName) &&
                nationalityId === TurkeyNationalityId
              ) {
                return false;
              } else {
                return true;
              }
            }
          )
          .test(
            i18n.t("resources.customers.related_persons.valid.valid_name"),
            i18n.t("resources.customers.related_persons.valid.valid_name"),
            function () {
              return name_regex.test(this.parent.fatherName);
            }
          ),
        documentNo: mixed().test(
          i18n.t(
            "resources.customers.related_persons.valid.select_identityDocumentNo"
          ),
          i18n.t(
            "resources.customers.related_persons.valid.select_identityDocumentNo"
          ),
          function () {
            const schema: any = this;
            const { isAuthorizedPerson }: any = schema.from[1].value;
            if (isAuthorizedPerson && !isExists(this.parent.documentNo)) {
              return false;
            } else {
              return true;
            }
          }
        ),
        validDate: mixed().test(
          i18n.t(
            "resources.customers.related_persons.valid.select_passportValidDate"
          ),
          i18n.t(
            "resources.customers.related_persons.valid.select_passportValidDate"
          ),
          function () {
            const schema: any = this;

            const identityType = identityCardTypes.find(
              (item: any) => item.id === this.parent.identityCardTypeId
            );
            const { isAuthorizedPerson }: any = schema.from[1].value;
            if (
              isExists(identityType) &&
              !schema.from[2].value.isExistCustomer
            ) {
              if (identityType.name === "tc_identity") return true;
              if (identityType.name === "tc_blue_card") return true;

              if (isAuthorizedPerson && !isExists(this.parent.validDate)) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          }
        ),
        serialNo: mixed().test(
          i18n.t(
            "resources.customers.related_persons.valid.enter_identitySerialNo"
          ),
          i18n.t(
            "resources.customers.related_persons.valid.enter_identitySerialNo"
          ),
          function () {
            const schema: any = this;
            const { isAuthorizedPerson }: any = schema.from[1].value;
            if (
              isAuthorizedPerson &&
              this.parent.identityCardTypeId ===
                identityCardTypes.find(
                  (cardType: any) => cardType.name === "tc_identity"
                )?.id &&
              !isExists(this.parent.serialNo) &&
              !schema.from[2].value.isExistCustomer
            ) {
              return false;
            } else if (
              isAuthorizedPerson &&
              this.parent.identityCardTypeId ===
                identityCardTypes.find(
                  (cardType: any) => cardType.name === "tc_blue_card"
                )?.id &&
              !isExists(this.parent.serialNo) &&
              !schema.from[2].value.isExistCustomer
            ) {
              return false;
            } else {
              return true;
            }
          }
        ),
        orderNo: mixed().test(
          i18n.t(
            "resources.customers.related_persons.valid.enter_identityOrderNo"
          ),
          i18n.t(
            "resources.customers.related_persons.valid.enter_identityOrderNo"
          ),
          function () {
            const schema: any = this;
            const { isAuthorizedPerson }: any = schema.from[1].value;
            if (
              isAuthorizedPerson &&
              this.parent.identityCardTypeId ===
                identityCardTypes.find(
                  (cardType: any) =>
                    cardType.name === "tc_identity" ||
                    cardType.name === "tc_blue_card"
                )?.id &&
              !isExists(this.parent.orderNo) &&
              !schema.from[2].value.isExistCustomer
            ) {
              return false;
            } else {
              return true;
            }
          }
        ),
      }),
    }),
  });

  return generalValidationSchema;
};

const generalEditValidation = () => {
  const generalEditValidationSchema = object({
    customerTypeId: number().required(
      i18n.t("resources.customers.valid.select_customerTypeId")
    ),
    customerKindId: number().required(
      i18n.t("resources.customers.valid.select_customerKindId")
    ),
    citizenOrTaxNumber: string()
      .nullable()
      .when("customerDetail", {
        is: (customerDetail: any) => customerDetail.isForeign,
        then: string().nullable(),
        otherwise: string().when(["customerTypeId", "customerDetail"], {
          is: (customerTypeId: number, customerDetail: any) =>
            customerTypeId !== customerTypeEnum.lead &&
            !customerDetail.isForeign,
          then: string()
            .nullable()
            .when("customerKindId", {
              is: (customerKindId: number) =>
                customerKindId === customerKindEnum.indivual ||
                customerKindId === customerKindEnum.soleProprietorship,
              then: string()
                .nullable()
                .matches(/^[0-9]+$/, "Must be only digits")
                .min(11, i18n.t("resources.customers.valid.equal_11"))
                .max(11, i18n.t("resources.customers.valid.equal_11"))
                .required(i18n.t("resources.customers.valid.enter_tcno")),
              otherwise: string()
                .nullable()
                .matches(/^[0-9]+$/, "Must be only digits")
                .min(10, i18n.t("resources.customers.valid.equal_10"))
                .max(10, i18n.t("resources.customers.valid.equal_10"))
                .required(i18n.t("resources.customers.valid.enter_vkno")),
            }),
          otherwise: string()
            .nullable()
            .when("customerKindId", {
              is: (customerKindId: number) =>
                customerKindId === customerKindEnum.indivual ||
                customerKindId === customerKindEnum.soleProprietorship,
              then: string()
                .nullable()
                .matches(/^[0-9]+$/, "Must be only digits")
                .min(11, i18n.t("resources.customers.valid.equal_11"))
                .max(11, i18n.t("resources.customers.valid.equal_11")),
              otherwise: string()
                .nullable()
                .matches(/^[0-9]+$/, "Must be only digits")
                .min(10, i18n.t("resources.customers.valid.equal_10"))
                .max(10, i18n.t("resources.customers.valid.equal_10")),
            }),
        }),
      }),
    name: mixed().when("customerKindId", {
      is: 1,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_customer_name"))
        .test(
          i18n.t("resources.customers.valid.valid_name"),
          i18n.t("resources.customers.valid.valid_name"),
          function () {
            if (!name_regex.test(this.parent.name)) {
              return false;
            } else {
              return true;
            }
          }
        ),
    }),
    surname: mixed().when("customerKindId", {
      is: 1,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_customer_surname"))
        .test(
          i18n.t("resources.customers.valid.valid_surname"),
          i18n.t("resources.customers.valid.valid_surname"),
          function () {
            if (!name_regex.test(this.parent.surname)) {
              return false;
            } else {
              return true;
            }
          }
        ),
    }),
    email: mixed().when("customerDetail", {
      is: (customerDetail: any) => customerDetail.isForeign,
      then: string()
        .email(i18n.t("resources.customers.valid.valid_email"))
        .required(i18n.t("resources.customers.valid.enter_email")),
      otherwise: string().when("customerKindId", {
        is: (customerKindId: any) =>
          customerKindId === customerKindEnum.corporate,
        then: string().email(i18n.t("resources.customers.valid.valid_email")),
        otherwise: string().nullable(true),
      }),
    }),
    commercialTitle: mixed().when("customerKindId", {
      is: 2,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_commercialTitle")),
    }),
    alias: mixed().when("customerKindId", {
      is: 2,
      then: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.enter_alias")),
    }),

    customerDetail: object().shape({
      statusId: string()
        .nullable()
        .required(i18n.t("resources.customers.valid.select_customerStatusId")),
      sectorId: mixed().test(
        i18n.t("resources.customers.valid.select_sectorId"),
        i18n.t("resources.customers.valid.select_sectorId"),
        function () {
          const schema: any = this;
          const { customerTypeId }: any = schema.from[1].value;

          if (
            customerTypeId === customerTypeEnum.real &&
            !isExists(this.parent.sectorId)
          ) {
            return false;
          } else {
            return true;
          }
        }
      ),
      taxFreeReasonId: mixed().when("isTaxFree", {
        is: true,
        then: string().required(
          i18n.t("resources.customers.valid.select_taxFreeReasonId")
        ),
      }),
      conditionId: mixed().test(
        i18n.t("resources.customers.valid.select_conditionId"),
        i18n.t("resources.customers.valid.select_conditionId"),
        function () {
          const schema: any = this;
          const { customerTypeId }: any = schema.from[1].value;

          if (
            customerTypeId === customerTypeEnum.real &&
            !isExists(this.parent.conditionId)
          ) {
            return false;
          } else {
            return true;
          }
        }
      ),
      supplierTypeId: mixed().when("isSupplier", {
        is: true,
        then: number()
          .typeError(i18n.t("resources.customers.valid.select_sectorId"))
          .required(i18n.t("resources.customers.valid.select_sectorId")),
      }),
      partnerLevelId: mixed().when("isBusinessPartner", {
        is: true,
        then: number()
          .typeError(i18n.t("resources.customers.valid.select_partnerLevelId"))
          .required(i18n.t("resources.customers.valid.select_partnerLevelId")),
      }),
      operatorCode: mixed().when("isOperator", {
        is: true,
        then: string()
          .max(
            4,
            i18n.t(
              "resources.customers.valid.not_valid_select_operatorCodeLength"
            )
          )
          .typeError(i18n.t("resources.customers.valid.select_operatorCode"))
          .required(i18n.t("resources.customers.valid.select_operatorCode")),
      }),
      mersisNo: string()
        .nullable()
        .matches(
          /^[0-9]+$/,
          i18n.t("resources.customers.valid.must_be_only_digit")
        )
        .min(16, i18n.t("resources.customers.valid.not_valid_mersisLength"))
        .max(16, i18n.t("resources.customers.valid.not_valid_mersisLength")),
      isActive: mixed().required(
        i18n.t("resources.customers.valid.select_isActive")
      ),
      eCommerceDescription: mixed().when("supplierTypeId", {
        is: (supplierTypeId: number) =>
          supplierTypeId === supplierEnum.e_commerce,
        then: string()
          .nullable()
          .required(
            i18n.t("resources.customers.valid.enter_eCommerceDescription")
          ),
      }),
      taxOfficeId: string()
        .nullable()
        .test(
          i18n.t("resources.customers.valid.select_tax_office"),
          i18n.t("resources.customers.valid.select_tax_office"),
          function () {
            const schema: any = this;
            const { customerKindId, customerTypeId, customerDetail }: any =
              schema.from[1].value;

            if (customerDetail.isForeign) {
              return true;
            }

            if (
              customerKindId !== customerKindEnum.indivual &&
              customerTypeId === customerTypeEnum.real &&
              !isExists(this.parent.taxOfficeId)
            ) {
              return false;
            } else {
              return true;
            }
          }
        ),
    }),
  });

  return generalEditValidationSchema;
};

export { generalEditValidation };

export default generalValidation;
